import './FiTextModal.scss';

import * as angular from 'angular';

import { Component } from '../Component';

@Component({
    controllerAs: 'vm',
    template: require('./FiTextModal.html'),
    bindings: {
        text: '@',
        title: '@',
    },
})
export class FiTextModal {
    static $inject = [
        '$mdDialog',
    ];


    constructor(
        private $mdDialog: angular.material.IDialogService,
    ) {
        //
    }

    $onInit() {
        //
    }

    close() {
        this.$mdDialog.cancel();
    }

}